import type { ReactNode } from "react";

type StateMessageProps = {
  variant?: "default" | "error";
  children: ReactNode;
};

export function StateMessage({
  variant = "default",
  children,
}: StateMessageProps) {
  const className =
    variant === "error" ? "gitg-state gitg-state--error" : "gitg-state";
  return <div className={className}>{children}</div>;
}
